import * as tslib_1 from "tslib";
import { Injector, Compiler, NgModuleFactory, Type, ViewContainerRef, InjectionToken } from '@angular/core';
export const CMS_SELECTOR = new InjectionToken('CMS_SELECTOR');
export class CmsLoaderService {
    constructor(injector, compiler, cmsWidgets) {
        this.injector = injector;
        this.compiler = compiler;
        this.cmsWidgets = cmsWidgets;
    }
    load(name, container) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const cmsWidget = this.cmsWidgets[name] ? this.cmsWidgets[name] : this.cmsWidgets['cms-default'];
            const tempModule = yield cmsWidget();
            let moduleFactory;
            if (tempModule instanceof NgModuleFactory) {
                // For AOT
                moduleFactory = tempModule;
            }
            else {
                // For JIT
                moduleFactory = yield this.compiler.compileModuleAsync(tempModule);
            }
            const cmsInjector = Injector.create({ providers: [
                    { provide: CMS_SELECTOR, useValue: name, multi: false }
                ], parent: this.injector, name: 'cms injector' });
            const entryComponent = moduleFactory.moduleType.entry;
            const moduleRef = moduleFactory.create(cmsInjector);
            const compFactory = moduleRef.componentFactoryResolver.resolveComponentFactory(entryComponent);
            container.createComponent(compFactory);
        });
    }
}
